import { TasksBlockType } from '../../../model/taskBoard';

export const useTasksBlock = () => {
    const types = [
        TasksBlockType.OVERDUE,
        TasksBlockType.NO_TERM,
        TasksBlockType.IN_PROCESS,
        TasksBlockType.TODAY,
        TasksBlockType.IN_WEEKS,
    ];

    return { types };
};
